import React from 'react';
import { Layout } from 'antd';

export default function Footer() {
  return (
    <Layout.Footer style={{ textAlign: 'center' }}>
      Github-User-Finder ©2020 Ruben Mateus
    </Layout.Footer>
  )
}
